// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__2l6Mg","pageButton":"Pagination_pageButton__28A9P","active":"Pagination_active__mpKjz"};